<template>
    <!-- Estado: Con Acceso -->
    <div class="tw:w-full tw:px-4 tw:mx-auto" v-if="ACCESS_MENU_ACTION(routeName)">
        <slot></slot>
    </div>

    <!-- Estado: Cargando -->
    <div v-else-if="isLoading" class="tw:w-full tw:px-4 tw:mx-auto tw:py-8">
        <div
            class="tw:bg-white tw:rounded-xl tw:shadow-sm tw:border tw:border-gray-200 tw:p-12 tw:flex tw:flex-col tw:items-center tw:justify-center tw:min-h-[400px]">
            <!-- Spinner animado de Tailwind -->
            <svg class="tw:animate-spin tw:w-10 tw:h-10 tw:text-blue-600 tw:mb-4" xmlns="http://www.w3.org/2000/svg"
                fill="none" viewBox="0 0 24 24">
                <circle class="tw:opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="tw:opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
            </svg>
            <h3 class="tw:text-lg tw:font-medium tw:text-gray-900">Cargando...</h3>
            <p class="tw:text-sm tw:text-gray-500 tw:mt-1">Verificando permisos de acceso</p>
        </div>
    </div>

    <!-- Estado: Sin Acceso -->
    <div v-else class="tw:w-full tw:px-4 tw:mx-auto tw:py-8">
        <div
            class="tw:bg-white tw:rounded-xl tw:shadow-sm tw:border tw:border-gray-200 tw:p-12 tw:flex tw:flex-col tw:items-center tw:justify-center tw:min-h-[400px] tw:text-center">

            <!-- Icono de Seguridad/Bloqueo -->
            <div class="tw:w-16 tw:h-16 tw:bg-red-50 tw:rounded-full tw:flex tw:items-center tw:justify-center tw:mb-5">
                <i class="fa fa-lock tw:text-2xl tw:text-red-500"></i>
            </div>

            <h3 class="tw:text-xl tw:font-bold tw:text-gray-900 tw:mb-2">Acceso Restringido</h3>
            <p class="tw:text-sm tw:text-gray-500 tw:max-w-md tw:mx-auto tw:mb-6">
                No tienes los permisos necesarios para visualizar esta sección. Si crees que esto es un error, por favor
                contacta al administrador del sistema.
            </p>

            <!-- Botón opcional para regresar (puedes quitarlo si no usas vue-router de esta forma) -->
            <button @click="$router.go(-1)"
                class="tw:inline-flex tw:items-center tw:px-5 tw:py-2.5 tw:text-sm tw:font-medium tw:text-gray-700 tw:bg-white tw:border tw:border-gray-300 tw:rounded-lg hover:tw:bg-gray-50 focus:tw:ring-4 focus:tw:ring-gray-100 tw:transition-all">
                <i class="fa fa-arrow-left tw:mr-2"></i> Regresar
            </button>

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { ACCESS_MENU_ACTION } from '@/validations/auth/AccessControlList';

export default {
    name: "AccessPage",
    props: {
        routeName: String,
    },
    computed: {
        ...mapState(['isLoading'])
    },
    methods: {
        ACCESS_MENU_ACTION,
    }
}
</script>